import BGDBook from "@assets/budget/bgd-book.svg";
import MainBlock from "@blocks/Container/MainBlock";
import WrapperBlock from "@blocks/Container/WrapperBlock";
import { AdsImu2 } from "@elements/Advertisement/variant/AdsImu";
import Divider from "@elements/Divider/Divider";
import Image from "@elements/ResponsiveImage/Image";
import Heading from "@elements/Typography/Heading";
import GELiveBlog from "@src/app/components/Layouts/GeneralElection/GELiveBlog";
import { ReactElement } from "react";
import { Link } from "react-router";

import { KeywordArticlesCards } from "./KeywordArticleCards";
import { KeywordVariantProps } from "./KeywordVariantHelper";

export default function BudgetVariant({
  tagAlias,
  tagName = "Keyword",
  sectionName,
  keywordArticles,
  showBreadcrumbs = true,
  showTitle = true,
  pageAdTargetValue,
  recordedVideo,
  liveBlog,
  articlePlacement = "main",
  articleSectionTitle = "அண்மைய செய்திகள்",
  budget2026PdfLink,
}: KeywordVariantProps): ReactElement {
  return (
    <WrapperBlock className="flex flex-col lg:flex-row justify-between">
      <>
        <MainBlock
          sectionName={tagName}
          showBreadcrumbs={showBreadcrumbs}
          showTitle={showTitle}
          className="lg:!pr-0 lg:border-0"
        >
          {recordedVideo && (
            <div className="mb-5">
              <div dangerouslySetInnerHTML={{ __html: recordedVideo }} />
            </div>
          )}
          {articlePlacement == "sidebar" && liveBlog && (
            <GELiveBlog variant="body" geLiveBlogContent={liveBlog} />
          )}
          {articlePlacement == "main" && (
            <KeywordArticlesCards
              tagAlias={tagAlias}
              sectionName={sectionName}
              keywordArticles={keywordArticles}
              pageAdTargetValue={pageAdTargetValue}
              placement={"main"}
            />
          )}
        </MainBlock>
        <div className="lg:w-4/12 lg:pr-xxs lg:pl-md min-h-[800px]">
          <div data-testid="side-block" className="w-full">
            <AdsImu2
              sectionName={sectionName}
              pageAdTargetType={pageAdTargetValue}
            />
            <Divider className="border-b border-gray-2200" />
            {budget2026PdfLink && (
              <BudgetBook pdfLink={budget2026PdfLink} tagName={tagName} />
            )}

            {articlePlacement == "sidebar" && (
              <>
                <Heading
                  Element="h2"
                  className="text-gray-100 text-md font-bold mt-5"
                >
                  {articleSectionTitle}
                </Heading>
                <KeywordArticlesCards
                  tagAlias={tagAlias}
                  sectionName={sectionName}
                  keywordArticles={keywordArticles}
                  pageAdTargetValue={pageAdTargetValue}
                  placement={"sidebar"}
                />
              </>
            )}
          </div>
        </div>
      </>
    </WrapperBlock>
  );
}

const BudgetBook = ({
  pdfLink,
  tagName,
}: {
  pdfLink: string;
  tagName: string;
}) => {
  return (
    <>
      <div className="flex items-center justify-center py-5">
        <Link to={pdfLink} target="_blank" className="flex items-center">
          <div className=" mr-2">
            <Image
              srcWidth={78}
              srcHeight={100}
              src={BGDBook}
              objectFit="contain"
              className=""
              alt={`${tagName} Book`}
            />
          </div>
          <div>
            <Heading
              Element="h3"
              className="text-red-100 text-md font-bold inline"
            >
              {tagName} புத்தகத்தை இங்கே பதிவிறக்கவும்
            </Heading>
          </div>
        </Link>
      </div>
      <Divider className="border-b border-gray-2200" />
    </>
  );
};
